export const TAX_INITIATE_CONTAINER_TAG_NAME = 'tax-initiate-container';
